export const CAMPUS_GUIDANCE_UPDATE_ERROR = "We are unable to update this campus guidance at this time";
export const CAMPUS_GUIDANCE_CREATE_ERROR = "We are unable to create this campus guidance at this time";

export const CAMPUS_GUIDANCE_NO_CONTENT_ERROR = "Please add some text for this guidance";
